<template>
    <div id="line-chart">
      <b-card class="border-radius" style="max-height:26rem">
        <div class="pb-1">
          <h5>Overtime</h5>
          <p style="font-weight:200;font-size:14px;">Approved Overtime</p>
        </div>
        <div>
          <canvas ref="canvas" width="200" height="300"></canvas>
        </div>
      </b-card>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { Line } from 'vue-chartjs'

  export default {
      extends: Line,
      data () {
        return {
          dataChart: {
            labels: [],
            datasets: [
              {
                label: "Approved",
                borderColor: "#80b6f4",
                backgroundColor: "#E0F7FA",
                pointBorderColor: "#80b6f4",
                pointBackgroundColor: "#80b6f4",
                pointHoverBackgroundColor: "#80b6f4",
                pointHoverBorderColor: "#80b6f4",
                pointBorderWidth: 10,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1,
                pointRadius: 3,
                fill: true,
                borderWidth: 4,
                data: []
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                id: "overtime",
                ticks: {
                    fontColor: "rgba(0,0,0,0.5)",
                    fontStyle: "bold",
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    padding: 20
                }
              }],
              xAxes: [{
                gridLines: {
                    display: false
                },
                ticks: {
                    padding: 4,
                    fontColor: "rgba(0,0,0,0.5)",
                    fontStyle: "bold"
                }
              }]
            },
          }
        }
      },
      mounted () {
        this.getData()
      },
      methods: {
        getData() {
          let totalHour = null
          this.$http.get(window.AppConfig.apiUrl + 'overtime-approved-stat').then(resp => {
            if (!resp.data) {
              this.$store.dispatch('notification/warning', 'No Data')
            } else {
              let foo = resp.data.overtime.reverse()
              foo.forEach((response, key) => {
                this.dataChart.labels.push(response.date)
                this.dataChart.datasets[0].data.push(response.total)
                totalHour += parseInt(response.total)
                this.renderChart(this.dataChart, this.options)
              })
              this.$emit('afterLoad', totalHour)
            }
          });
        }
      }
  }
</script>